
import { defineComponent, ref } from 'vue'
import {
  IonContent,
  IonItem,
  IonList,
  IonText,
  IonImg,
  IonThumbnail,
  IonBadge,
} from '@modus/ionic-vue'
import { useRoute } from 'vue-router'
import useProductsInCategory from '@/composables/products'
import useCategories from '@/composables/categories'

function getCurrencyFormat() {
  const intl = new Intl.NumberFormat(navigator.language, {
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'USD',
  })

  return intl.format
}

export default defineComponent({
  name: 'Category',
  components: {
    IonContent,
    IonItem,
    IonList,
    IonText,
    IonImg,
    IonThumbnail,
    IonBadge,
  },
  async setup() {
    const categoryId = ref(useRoute().params.categoryId as string)

    const { products } = await useProductsInCategory(categoryId.value)

    const { getCategoryById } = await useCategories()

    const category = ref(getCategoryById(categoryId.value))

    const currency = getCurrencyFormat()

    document.title = category.value.title

    return { products, currency, category }
  },
})
